import { Button } from './ui/button';

const CallToAction = () => {
  return (
    <section className="py-20 bg-gradient-to-r from-fembot-pink to-fembot-light-pink">
      <div className="container-custom">
        <div className="flex flex-col items-center text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 max-w-2xl">
            Ready to transform your Discord server experience?
          </h2>
          <p className="text-lg text-white/90 mb-8 max-w-2xl">
            Join the many servers already using Fembot to enhance their communities
          </p>
          <Button className="bg-white text-fembot-pink hover:bg-gray-100 px-8 py-6 text-lg font-medium rounded-md shadow-lg hover:shadow-xl transition-all"
            onClick={() => window.location.href = "/info"}
          >
            Add Fembot to Discord
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
